import React from 'react';
import { useState } from 'react';
import { Button, Card, Col, Container, ListGroup, Modal, Row } from 'react-bootstrap';
import './ProjectCart.css';
//import Button from 'react-bootstrap/Button';
//import Modal from 'react-bootstrap/Modal';


const ProjectCart = ({project}) => {
  const {project_name,tech_used,live_site,proj_img,cliet_site,server_side,vwdtl_img1,
  vwdtl_img2,vwdtl_img3,vwdtl_img4,vwdtl_img5,vwdtl_p1,vwdtl_p2,vwdtl_p3,vwdtl_p4,vwdtl_p5}=project; 
 
  const values = [true];
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);

  
  function handleShow(breakpoint) {
    setFullscreen(breakpoint);
    setShow(true);
  }

    return (
        <div>
            <Card style={{}} className='mx-auto card_style h-100 mb-4'>
                <Card.Img variant="top" src={proj_img} className="card_img"/>
                <Card.Body>
                    <Card.Title><span className='proj_name'>Project Name:</span><span className='dyna_proj'> {project_name}</span></Card.Title>
                    <Card.Text >
                      <h5><span className='tech_used'>Technology Used:</span></h5>  
                      <p className='font-weight-bold'>{tech_used}</p> 
                    </Card.Text>
                </Card.Body>
                 
                     <a href={live_site} target="_blank" className="text-warning font-weight-bold bg-dark p-3 btn_card">Live Website Link</a>
                 
                <Card.Body>
                   
                    <Card.Link><span className='font-weight-bold text-danger fs-5 fw-bold '>GitHub :</span><span className='mr-3 ml-2'><a href={cliet_site} target="_blank" className="bg-info p-2 text_color mx-2 rounded">Client Code</a></span><span><a href={server_side} target="_blank" className="bg-info p-2 text_color rounded">Server Code</a></span> </Card.Link>
                </Card.Body>
               

          {/* Modal */}
          <>
            {values.map((v, idx) => (
              <button key={idx} className="w-full p-2" style={{fontWeight:'bold',backgroundColor:"magenta",color:"blanchedalmond"}} onClick={() => handleShow(v)}>
                View Details
                {typeof v === 'string' && `below ${v.split('-')[0]}`}
              </button>
            ))}
            <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
              <Modal.Header closeButton style={{backgroundColor:"#19092c"}}>
                <Modal.Title style={{marginLeft:90,color:"magenta",fontWeight:'bold'}} >Below The Description Of Each Page Of This Website.</Modal.Title>
              </Modal.Header>
              <Modal.Body className='mdl_body'>
                <Container>
                <Row  className='modal_style'>
                  <Col xs={6} md={7}  className='mt-3'>
                    <img src={vwdtl_img1} alt="" className='w-full h-full bg-info'/>
                  </Col>
                  <Col xs={12} md={5} className='mt-5' style={{textAlign:'justify',color:'ghostwhite',fontWeight:500}}>
                     {vwdtl_p1}
                  </Col>  
                   
                  <Col xs={6} md={7}>
                    <img src={vwdtl_img2} alt="" className='w-full h-full mt-4'/>
                  </Col>
                  <Col xs={12} md={5}  className='mt-5' style={{textAlign:'justify',color:'ghostwhite',fontWeight:500}}>
                     {vwdtl_p2}
                  </Col>
                  
                  <Col xs={6} md={7}>
                    <img src={vwdtl_img3} alt="" className='w-full h-full mt-4'/>
                  </Col>
                  <Col xs={12} md={5}  className='mt-5' style={{textAlign:'justify',color:'ghostwhite',fontWeight:500}}>
                     {vwdtl_p3}
                  </Col>
                  
                  <Col xs={6} md={7} className="mb-4">
                    <img src={vwdtl_img4} alt="" className='w-full h-full mt-4'/> 
                  </Col>
                  <Col xs={12} md={5}  className='mt-5' style={{textAlign:'justify',color:'ghostwhite',fontWeight:500}}>
                     {vwdtl_p4}
                  </Col>
                  
                  <Col xs={6} md={7} className="mb-4">
                    <img src={vwdtl_img5} alt="" className='w-full h-full mt-4'/> 
                  </Col>
                  <Col xs={12} md={5}  className='mt-5' style={{textAlign:'justify',color:'ghostwhite',fontWeight:500}}>
                     {vwdtl_p5}
                  </Col>
                </Row>
                </Container>
               
              </Modal.Body>
            </Modal>
          </>

        </Card>
        </div>
    );
};

export default ProjectCart;